import React, { useMemo } from 'react'
import { CCol, CRow } from '@coreui/react-pro'
import { TransactionsDetails } from '../atoms/TransactionsDetails/component'
import { useWalletsList } from '../list/hooks'
import { WalletStatus } from '../atoms/TransactionsDetails/const'

export const InProgressDetails = () => {
  const { inProcess, allCurrencies } = useWalletsList()

  const { localBalances } = inProcess

  const currencies = useMemo(
    () => localBalances.map((item) => item.currency),
    [localBalances],
  )

  return (
    <CRow>
      <CCol>
        <TransactionsDetails
          currenciesFromWallet={currencies}
          allCurrencies={allCurrencies}
          walletStatus={WalletStatus.inProgress}
        />
      </CCol>
    </CRow>
  )
}
